<div class="topdiv">
    <label i18n="@@spmsUserReg" class="textColour">Objects Groups</label>
    <span class="example-spacer"></span>
      <div style="margin-top: 25px;">
          <form novalidate [formGroup]='validations_form'>
            <div class="row">
              <div class="col-3"></div>
              <div class="col-lg-3">
                <mat-form-field appearance="outline">
                  <mat-label i18n="@@RCFormulaexpression">Object Group Name</mat-label>
                  <input matInput type="text" placeholder="Object Group Name" formControlName="groupname" [(ngModel)]="reportCreationData.groupname"  maxlength="100" required readonly>
                  <mat-error *ngFor="let validation of validation_messages.groupname">
                    <span
                        *ngIf="validations_form.get('groupname').hasError(validation.type) && (validations_form.get('groupname').dirty || validations_form.get('groupname').touched)">
                        {{ validation.message }}
                    </span>
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="col-3" style="text-align: center;">
                <mat-form-field appearance="outline">
                  <mat-label i18n="@@TMSTAFFMASTERfirstname">Description</mat-label>
                  <input matInput type="text" placeholder="Description" formControlName="description" [(ngModel)]="reportCreationData.description"  maxlength="100" required readonly>
                  <mat-error *ngFor="let validation of validation_messages.description">
                    <span
                        *ngIf="validations_form.get('description').hasError(validation.type) && (validations_form.get('description').dirty || validations_form.get('description').touched)">
                        {{ validation.message }}
                    </span>
                </mat-error>
                </mat-form-field>
              </div>
              <div class="col-3"></div>

            </div>
          </form>
        </div>

        <div class="row">
          <div class="col-2"></div>
          <div style="width: 32%;">
            <div class="seperateDiv">
              <ag-grid-angular class="ag-theme-balham table-width-fields tablestyles square scroolbar-dusty-grass square thin" [columnDefs]="columnDefsForObjects" [animateRows]="true" [defaultColDef]="defaultColDef" [suppressPaginationPanel]="true" [rowMultiSelectWithClick]="true"
                [rowSelection]="rowSelectionForTablesFields" [rowHeight]="35" [headerHeight]="35" [enableBrowserTooltips]="true" [floatingFiltersHeight]="45" [enableRangeSelection]="true" [debug]="true"
                (gridReady)="onGridReadyForObjects($event)" (rowSelected)="onRowSelected($event)"  [hidden]="!true">
              </ag-grid-angular>
            </div>
          </div>
         

          <div style="width: 2%;margin: auto 5px;margin-right: 12px;font-size: 1.8rem;text-align: center;">
            <div>
              <div (click)="pushDataToSelectedFieldsGrid()">
                <em class="fas fa-step-forward" title="Move selected rows to
                Right"></em>
              </div>
              <div (click)="pushDataToSelectedFieldsGridComplete()">
                <em class="fas fa-forward" title="Move all rows to
                Right"></em>
              </div>
              <div (click)="popDataToSelectedFieldsGridComplete()">
                <em class="fas fa-backward" title="Move all rows to
                Left"></em>
              </div>
              <div (click)="popDataToSelectedFieldsGrid()">
                <em class="fas fa-step-backward" title="Move selected rows to
                Left"></em>
              </div>
            </div>
          </div>


          <div style="width: 32%;">
            <div class="seperateDiv">
              <ag-grid-angular class="ag-theme-balham table-width-fields tablestyles square scroolbar-dusty-grass square thin" [columnDefs]="columnDefsForSelectedFields"  [animateRows]="true"  [defaultColDef]="defaultColDef" [suppressPaginationPanel]="true" [rowMultiSelectWithClick]="true"
              [rowSelection]="rowSelectionForTablesFields" [rowHeight]="35" [headerHeight]="35" [enableBrowserTooltips]="true" [floatingFiltersHeight]="45" [enableRangeSelection]="true" [debug]="true" [components]="components"
              (gridReady)="onGridReadyForSelectedTableFields($event,ngModelObjectTemporary)" (rowSelected)="onRowSelectedToRemove($event)" [hidden]="!true">
              </ag-grid-angular>
            </div>
          </div>
          <div class="col-2"></div>

        </div>

     

        <div class="row mb-1 topRowMargins" style= "position:sticky;left:0;bottom:0;width:100%;background-color: #fff; ">
          <div class="col-lg text-center" >
            <div style="text-align: end">
              <form novalidate [formGroup]="formValidCheckbox">
               

                <button i18n="@@TMRunButton"  type="button" (click)="save()" class="actionButton btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
                style="padding-left:1.2rem;padding-right: 1.2rem" [style.background-color]="backgroundColorButton" [class.allocateButtons]="allocateButtonsBoolean" [class.allocateButtons1]="allocateButtons1Boolean">Update</button>


                <button i18n="@@TMRunButton" type="button" (click)="cancel()" class="cancelButton btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
                style="padding-left:1.2rem;padding-right: 1.2rem" [style.border-color]="backgroundColorButton" [class.allocateButtons]="allocateButtonsBoolean" [class.allocateButtons1]="allocateButtons1Boolean" >Cancel</button>

              </form>
            </div>
          </div>
        </div>
  </div>

